import { SiteMetadata } from '@/api/fe-api/domain/entities/site-metadata';
import {
  Disclosure,
  DisclosurePanel,
  DisclosureTitle,
} from '@/components/ui/disclosure';

import { SiteMetadataRow } from './site-metadata-row';

export type SiteMetadataSectionProps = {
  section: SiteMetadata.Section;
  documentIndexes: Record<string, number>;
};

export function SiteMetadataSection({
  section,
  documentIndexes,
}: SiteMetadataSectionProps) {
  return (
    <Disclosure>
      <DisclosureTitle>{keyLabel(section.key)}</DisclosureTitle>
      <DisclosurePanel>
        {section.groups.map((group) => (
          <dl key={group.key} className="mb-3 border border-gray-200">
            {group.rows.map((row) => (
              <SiteMetadataRow
                key={row.key}
                row={row}
                documentIndexes={documentIndexes}
              />
            ))}
          </dl>
        ))}
      </DisclosurePanel>
    </Disclosure>
  );
}

function keyLabel(key: string) {
  switch (key) {
    case 'pcs': {
      return 'PCS';
    }
  }

  // Always try to make it human readable as fallback
  return key
    .split('_')
    .join(' ')
    .replace(/\bid\b/gi, 'ID')
    .replace(/\baccure\b/gi, 'ACCURE')
    .replace(/^\w/, (c) => c.toUpperCase());
}
